{
  "loading": "Загрузка...",
  "placeholder": "Выбрать…"
}
